<script>
import axios from 'axios';
import utilsService from '@/api/utilsService';

const apiUrl = `${process.env.VUE_APP_API_URL}/api/diccionarios`;

const diccionarioService = {
  async getByTipo(tipo) {
    try {
      const response = await axios.get(apiUrl, {
        params: { tipo },
        headers: {
          'Authorization': `Bearer ${utilsService.getToken()}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching diccionario: ' + error.message);
    }
  },
};

export default diccionarioService;
</script>
